export default function (somenteVendas = false) {
  let window = `relatorio.leiloes.lotes`
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Relatório de Lotes',
    width: '600',
    height: '450',
    minHeight: '500px',
    backdrop: false,
    maximize: false,
    clickOutside: false,
    windowClass: 'erp-window',
    contentClass: 'overflow-hidden',
    props: {
      somenteVendas: somenteVendas
    }
  }, () => import('./Lotes.vue'))
    .then((wid) => {
      console.log(wid)
    }) // return wid
}
